import { useFormContext, Controller } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { Task } from '../../tasks/models';
import ReadOnlyEditor from '../../../core/components/ReadOnlyEditor';
import { ControlledRichText } from '../../../core/formValidation';

interface TaskInstructionsTabProps {
  task?: Task | null;
  editing?: boolean;
}

export const TaskInstructionsTab = ({ task, editing = false }: TaskInstructionsTabProps) => {
  const intl = useIntl();
  const form = useFormContext();

  return (
    <>
      {editing ? (
        <Controller
          name="description"
          control={form.control}
          render={({ field }) => (
            <ControlledRichText
              input={field}
              meta={{ initial: task?.description }}
              id="description"
              placeholder=""
            />
          )}
        />
      ) : (
        <ReadOnlyEditor text={task?.description === undefined ? '' : task.description} />
      )}
    </>
  );
};
